// src/contracts/ops/opsClone.ts
//
// opsClone (v1)
// -------------
// Global invariant: never leak a live mutable reference across boundaries.
// Uses structuredClone when available. Falls back to JSON clone for ops state,
// which is intentionally POJO-only (no functions, maps, dates, blobs).
//

export function cloneState<T>(state: T): T {
  // Prefer platform clone (handles nested arrays/objects safely)
  try {
    const clone = globalThis.structuredClone;
    if (typeof clone === "function") return clone(state);
  } catch {
    // fall through
  }

  // Fallback: JSON clone (safe given ops state contract constraints)
  try {
    return JSON.parse(JSON.stringify(state)) as T;
  } catch {
    // last resort: return as-is (should be extremely rare)
    return state;
  }
}
